import { has } from 'lodash';
import { HomePageCid } from './constant';

const Statistics = Mach.requireModule('Statistics');

const lxViewReport = (bid: string, lab?: object) => {
  if (!bid) {
    return;
  }
  Statistics?.view(HomePageCid, bid, lab);
};

const lxClickReport = (bid: string, lab?: object) => {
  if (!bid) {
    return;
  }
  Statistics?.click(HomePageCid, bid, lab);
};

// url拼接参数
const buildURL = (url: string, query: Record<string, unknown>) => {
  if (!url) return '';
  if (query && JSON.stringify(query) !== '{}') {
    const queryArr = [] as string[];
    for (const key in query) {
      if (has(query, key)) {
        queryArr.push(`${key}=${query[key]}`);
      }
    }
    if (url.indexOf('?') !== -1) {
      url = `${url}&${queryArr.join('&')}`;
    } else {
      url = `${url}?${queryArr.join('&')}`;
    }
  }
  return url;
};

export {
  lxViewReport,
  lxClickReport,
  buildURL
};
